// extracted by mini-css-extract-plugin
module.exports = {"paginationList":"_a95e1fb4","paginationItem":"_474c7be3","page":"_4e220069","arrowWrapper":"_6200530"};